/**
 * API / WebSocket base URLs for Aura Finance frontend.
 * Production: set REACT_APP_API_URL and REACT_APP_WS_URL in Vercel (or .env.production).
 * Local dev: .env.development defaults to localhost:3001.
 */

const _rawApiUrl =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  'http://localhost:3001';

/** Ignore deployment placeholders baked into production builds when testing locally. */
export const API_BASE_URL = _rawApiUrl.includes('REPLACE_WITH')
  ? 'http://localhost:3001'
  : _rawApiUrl;

/** WebSocket origin (no path). Prefer REACT_APP_WS_URL in production (wss://). */
export const WS_BASE_URL = (() => {
  const rawWs = process.env.REACT_APP_WS_URL;
  if (rawWs && !rawWs.includes('REPLACE_WITH')) {
    return rawWs.replace(/\/$/, '');
  }
  if (API_BASE_URL.startsWith('https://')) {
    return API_BASE_URL.replace(/^https/, 'wss');
  }
  if (API_BASE_URL.startsWith('http://')) {
    return API_BASE_URL.replace(/^http/, 'ws');
  }
  return 'ws://localhost:3001';
})();

/** Build a WebSocket URL for a given path (e.g. `/ws/news/{sessionId}`). */
export function buildWebSocketUrl(path) {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${WS_BASE_URL}${normalized}`;
}
